(() => {
  // Scoped to the PDP shell (.pg-site). The landing/collection have their own
  // controllers (pegasi-motion.js, pegasi-collection.js), so this only needs to
  // own the two behaviours that live inside .pg-site: the header menu toggle and
  // the product form's variant sync.
  //
  // Removed (were dead code, and two were inferior duplicates the audit flagged):
  //   - initGallery: swapped main.src to a full-resolution original on tap,
  //     stripping srcset. Its [data-pg-thumb]/[data-pg-main-image] hooks don't
  //     exist on the pane gallery (pegasi-flow.js owns [data-pg-thumb-target]).
  //   - initDragTrack: animated progress.style.width (layout) on every scroll.
  //     The landing carousel uses pegasi-motion.js createReportsDrag() instead,
  //     which drives it with quickSetter('xPercent') (transform only).
  //   - initFilters: [data-pg-filter] hooks don't exist; the collection uses
  //     [data-pgc-filter] handled by pegasi-collection.js.

  const initMenu = (root) => {
    const header = root.querySelector('[data-pg-header]');
    const toggle = root.querySelector('[data-pg-menu-toggle]');
    const nav = header?.querySelector('.pg-nav');
    if (!header || !toggle || toggle.dataset.ready) return;

    toggle.dataset.ready = 'true';

    // Matches the landing (pegasi-motion.js) and collection (pegasi-collection.js)
    // menus: aria state, focus first link on open, and close on Escape, on a link
    // tap, and when the viewport grows back past the mobile breakpoint.
    const close = (returnFocus) => {
      header.classList.remove('is-menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', toggle.dataset.pgMenuOpenLabel || 'Open menu');
      if (returnFocus) toggle.focus({ preventScroll: true });
    };

    toggle.addEventListener('click', () => {
      const open = header.classList.toggle('is-menu-open');
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? (toggle.dataset.pgMenuCloseLabel || 'Close menu') : (toggle.dataset.pgMenuOpenLabel || 'Open menu'));
      if (open && nav) nav.querySelector('a')?.focus({ preventScroll: true });
    });

    nav?.addEventListener('click', (event) => {
      if (event.target.closest('a')) close(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && header.classList.contains('is-menu-open')) close(true);
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 760 && header.classList.contains('is-menu-open')) close(false);
    }, { passive: true });
  };

  const initProductForm = (root) => {
    const selector = root.querySelector('[data-pg-variant-select]');
    const input = root.querySelector('[data-pg-variant-id]');
    const price = root.querySelector('[data-pg-price]');
    const submit = root.querySelector('[data-pg-submit]');
    const submitLabel = submit?.querySelector('[data-pg-submit-label]');
    if (!selector || !input || !submit || selector.dataset.ready) return;

    selector.dataset.ready = 'true';
    const update = () => {
      const option = selector.options[selector.selectedIndex];
      const available = option.dataset.available === 'true';
      input.value = option.value;
      submit.disabled = !available;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      // Labels come from the button's data attributes, which the purchase gate
      // fills from Theme settings. Hardcoding them here overwrote a merchant's
      // wording the moment a variant was switched.
      if (submitLabel) {
        submitLabel.textContent = available
          ? (submit.dataset.pgLabelAvailable || 'Add to cart')
          : (submit.dataset.pgLabelUnavailable || 'Notify me when available');
      }
    };

    selector.addEventListener('change', update);
    update();
  };

  const init = (scope = document) => {
    scope.querySelectorAll('.pg-site').forEach((root) => {
      initMenu(root);
      initProductForm(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
